import React, { Component } from "react";
import Select from "react-select";
import Api from "../../Services/Api";

class DDLPositionJob extends Component {
    constructor(props) {
        super(props);
        this.state = {
            jobData: [],
            value: null
            // roleAccess: true,
        }
    }

    componentDidMount() {
        if (this.props.companyId) {
            this.getPositionJobDdl(this.props.companyId);
        }
    }

    clear = () => {
        this.setState({
            jobData: []
        })
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.companyId !== this.props.companyId) {
            if (this.props.companyId) {
                this.getPositionJobDdl(this.props.companyId);
            } else {
                this.clear();
            }
        }
    }

    getPositionJobDdl(companyId) {
        let payload = {
            companyId: companyId,
        }

        Api.create('MASTERDATA_EKSAD').postGetPositionJobDdl(payload).then(
            (res) => {
                if (res.ok && res.data.status === 'S') {
                    let array = []
                    if (res.data.data === null) {
                        this.setState({
                            jobData: []
                        })
                    } else {
                        if (this.props.all) {
                            array.push({
                                value: "ALL",
                                label: "All Job"
                            })
                        }

                        res.data.data.map((item) => {
                            array.push({
                                value: item.jobId,
                                label: item.jobTitle
                            })
                        })
                        this.setState({
                            jobData: array
                        })
                    }
                }
            })
    }

    render() {
        const { label, placeHolder, mandatory, onClickView, disabled, box, hierarchy, companyId, valueCombo, onChangeCombo, name } = this.props

        return (
            <div className="margin-bottom-20px">
                <div className="margin-5px">
                    <div className="txt-site txt-11 txt-main txt-bold">
                        <h4>{label} {mandatory && <span style={{ color: 'red' }}>*</span>}</h4>
                    </div>
                </div>
                <Select
                    style={{ backgroundColor: disabled && "#E6E6E6" }}
                    styles={{
                        menu: (provided) => ({ ...provided, zIndex: 9999, fontFamily: "FontFirst2, Helvetica Neue, Helvetica, Arial, sans-serif" }),
                        control: base => ({
                            ...base,
                            fontFamily: "FontFirst2, Helvetica Neue, Helvetica, Arial, sans-serif"
                        }),
                    }}
                    isDisabled={!this.state.roleAccess ? disabled && true : this.state.roleAccess}
                    options={this.state.jobData}
                    onChange={(e) => {
                        if (name) {
                            onChangeCombo({ [name]: e.value, [name + "Select"]: e });
                        } else {
                            onChangeCombo({ jobId: e.value, ["jobId" + "Select"]: e })
                        }
                    }}
                    value={valueCombo ?? null}
                    {...this.props}
                />
            </div>
        );
    }
}

export default DDLPositionJob